import _Div from './Div';

export type { FDivProps } from './Div';
export * from './type';

export const Div = _Div;

export default Div;
